// extracted by mini-css-extract-plugin
export default {"table":"UserStats_table__A0Zcq","searchbar":"UserStats_searchbar__NrZu8","sort":"UserStats_sort__Y5DZ9"};